module.exports = __webpack_public_path__ + "img/event_icon_mobile_white.86db39f7.png";